export class EpLocator {
  static getElById(id: string, targetEl?:  HTMLElement): HTMLElement {
    if(!!targetEl){
      return targetEl.querySelector(`#${id}`);
    }
    return document.getElementById(id);
  }

  static queryAll(css: string): HTMLElement[] {
    return Array.from(document.querySelectorAll(css));
  }

  static query(css: string): HTMLElement {
    return document.querySelector(css);
  }

  static createElement(elTag: string): HTMLElement {
    return document.createElement(elTag);
  }

  static getByTagName(elTag: string): Element[] {
    return Array.from(document.getElementsByTagName(elTag));
  }
}
